export const ENDPOINT_APPEALS_FIND_ALL = '/api/appeals/list';
export const ENDPOINT_APPEALS_CREATE_ONE = '/api/appeals/create';
export const ENDPOINT_APPEALS_UPDATE_ONE = '/api/appeals/update';
